import { BlockSpace } from 'module/ui/components/atoms/space';
import { FormattedMessage } from 'react-intl';
import { PlaceholderText } from '../styles';
import { ConditionTypes } from './types';

export const PlaceholderValues = ({
  placeholderFor,
}: {
  placeholderFor: ConditionTypes;
  disabled?: boolean;
  onVisibilityChange: (visibility: boolean) => void;
}) => (
  <BlockSpace direction="vertical" size={16}>
    <PlaceholderText>
      {placeholderFor === ConditionTypes.Triggers ? (
        <FormattedMessage
          id="settings.integrations.sf.automation.create.trigger.placeholder"
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      ) : (
        <FormattedMessage
          id="settings.integrations.sf.automation.create.matches.placeholder"
          values={{
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      )}
    </PlaceholderText>
  </BlockSpace>
);
